import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ItemPage from './Item';
import DefaultTabs from 'components/tab/DefaultTabs';
import { useCookies } from 'react-cookie';
import { IProject } from 'utils/types/storyTypes';
import InAppStoreListPage from '../../sales/inappStore/InAppStoreListPage';
import NewNoticeListPage from '../../operation/notice/NewNoticeListPage';
import CouponListPage from '../../operation/coupon/CouponListPage';

interface IProps {
  currentProject: IProject;
  refreshCounter: number;
}

/**
 *
 * @param {*} props
 * @returns {리소스 메인 페이지 - 기본 값 배경 테이블}
 */
const OperationMainPage: React.FC<IProps> = ({
  currentProject,
  refreshCounter,
}: IProps) => {
  const [cookies, setCookie] = useCookies();

  const { projectId } = useParams();
  const navigate = useNavigate();
  const {
    state: {
      operationTabKey = cookies.operationTabKey
        ? cookies.operationTabKey
        : 'item',
    },
  } = useLocation();

  useEffect(() => {
    onClickOperationTab(operationTabKey);
  }, [refreshCounter]);

  // tab누를때
  const onClickOperationTab = (activeKey) => {
    console.log(`onClickOperationTab `, activeKey);

    setCookie('operationTabKey', activeKey);

    navigate(`/story/${projectId}/operation/${activeKey}`, {
      state: {
        operationTabKey: activeKey,
        tabKey: 'operation',
      },
    });
  };

  /// 작품 관리 내부 탭 메뉴 리스트
  const OperationTabMenuList = [
    {
      key: 'item',
      tab: '게임 아이템',
      table: <ItemPage currentProject={currentProject}></ItemPage>,
    },
    {
      key: 'notice',
      tab: '공지사항',
      table: <NewNoticeListPage selectProject={currentProject} />,
    },
    {
      key: 'inapp',
      tab: '인앱상품',
      table: <InAppStoreListPage selectProject={currentProject} />,
    },
    {
      key: 'coupon',
      tab: '쿠폰',
      table: <CouponListPage selectProject={currentProject} />,
    },
  ];
  return (
    <DefaultTabs
      type='line'
      onChange={onClickOperationTab}
      activeKey={operationTabKey ? operationTabKey : 'item'}
    >
      {OperationTabMenuList.map((v) => (
        <Tabs.TabPane key={v.key} tab={v.tab}>
          {v.table}
        </Tabs.TabPane>
      ))}
    </DefaultTabs>
  );
};

export default OperationMainPage;
